import { FeatureFlag } from '../FeatureFlag';

export const disableSessionBarrier = new FeatureFlag({
    key: 'disable-session-barrier',
    createdOn: '2024-04-10',
    defaultValue: false,
});
